<template>
  <div>
    <edit-input class="tw-mr-4 tw-w-full secondary-c" :label="$t('profile.export_data')" icon="fa fa-file-export">
      <p class="tw-mb-4 tw-text-gray-400">{{ $t('profile.export_data_description') }}</p>

      <a @click="exportProfile" target="_blank" class="ghost-button">
        {{ $t('fields.download') }}
      </a>
    </edit-input>

    <edit-input class="tw-mr-4 tw-w-full secondary-c" :label="$t('gdpr.privacy_documents')" icon="fa fa-file">
      <p class="tw-mb-4 tw-text-gray-400">{{ $t('gdpr.privacy_documents_description') }}</p>

      <div v-for="policy in policies" :key="policy.id">
        <a target="_blank" :href="`/about/policies/${policy.slug}`" class="tw-flex tw-block tw-items-center">
          <span class="tw-mr-2 tw-block"><i class="fa fa-angle-right"></i></span>
          <span class="tw-block">{{ policy.name }}</span>
        </a>
      </div>

      <div>
        <a href="https://www.thehuddle.nl/privacy-verklaring/" target="_blank"
           class="tw-flex tw-block tw-items-center">
          <span class="tw-mr-2 tw-block"><i class="fa fa-angle-right"></i></span>
          <span class="tw-block">Privacy Policy The Huddle B.V.</span>
        </a>
      </div>

    </edit-input>

    <edit-input class="tw-mr-4 tw-w-full tw-text-red-500" :label="$t('profile.delete_account')" icon="fa fa-trash">
      <p class="tw-mb-4 tw-text-red-400">{{ $t('profile.delete_account_description') }}</p>

      <a @click="openDeleteProfilePopup" target="_blank"
         class="ghost-button tw-text-red-500 hover:tw-bg-red-500 tw-border-red-500">
        {{ $t('profile.delete_account_button') }}
      </a>
      <p class="tw-text-gray-500 tw-italic tw-text-sm tw-mt-4">* {{ $t('profile.delete_account_ps') }}</p>
    </edit-input>


    <modal v-if="popup_open && popup_name === 'delete_profile'" modal_name="delete_profile" type="medium"
           :title="`${$t('profile.delete_account')}`" icon="fa fa-exclamation-triangle"
           class="tw-relative">
      <template v-slot:modal-content>
        {{ $t('profile.delete_my_account_confirm') }}
      </template>
      <template v-slot:modal-bottom>
        <div class="subtle-button slim" @click="closeDeleteProfilePopup">
          {{ $t('fields.cancel') }}
        </div>
        <div class="general-button btn-v2 slim tw-bg-red-500" @click="deleteProfile">
          {{ $t('profile.delete_account_button') }}
          <i class="far fa-trash-alt"></i>
        </div>
      </template>
    </modal>

  </div>
</template>

<script>
import axios from 'axios';
import EditInput from '../EditInput.vue';
import Notification from '@/resources/assets/js/vue/lib/models/Notification';
import Modal from '../../../mixins/v2/Modal';

export default {
  name: 'PrivacyTab',
  mixins: [Modal],

  components: {
    'edit-input': EditInput,
  },
  props: ['settings'],
  data() {
    return {
      policies: [],
    }
  },
  methods: {
    saveAccount() {
      this.$emit('saveAccount');
    },
    exportProfile() {
      axios.get('/api/v3/profile/export').then((response) => {
        Notification.insert({
          data: [
            {
              title: this.$t('profile.export_being_prepared'),
            },
          ],
        });
      }).catch((error) => {
        Notification.insert({
          data: [
            {
              status: 'error',
              title: this.$t('profile.preparing_export_failed'),
            },
          ],
        });
      });
    },
    closeDeleteProfilePopup() {
      this.closePopup('delete_profile');
    },
    openDeleteProfilePopup() {
      this.openPopup('delete_profile');
    },
    deleteProfile() {
      this.closeDeleteProfilePopup();
      axios.delete('/api/v3/profile').then((response) => {
        window.location = '/login';
      });
    },
    getPrivacyPolicies() {
      axios.get('/api/v3/policies').then((response) => {
        this.policies = response.data.data;
      });
    }
  },
  mounted() {
    this.getPrivacyPolicies();
  }
}
</script>